<template>
    <div class="portal-wrapper">
      <div class="summary-container">
        
        <!-- ─── HEADER SECTION ─── -->
        <header class="summary-header">
          <h1 class="main-title">Summary</h1>
          <p class="sub-title">
            Review your rent advance details before confirming.
          </p>
        </header>
  
        <!-- ─── BREAKDOWN METRIC CARD ─── -->
        <div class="breakdown-card">
          
          <!-- Editable Amount Requested Section -->
          <div class="amount-requested-block">
            <label class="meta-label text-uppercase">Amount Requested</label>
            <div class="input-display-row">
              <span class="currency-symbol">₦</span>
              <input 
                type="text" 
                class="editable-amount-input"
                :value="formattedAmount"
                @input="handleAmountInput"
                placeholder="0.00"
              />
            </div>
          </div>
  
          <hr class="card-divider" />
  
          <!-- Dual Column Cost Parameter Block Grid -->
          <div class="cost-summary-grid">
            
            <!-- Column Left: Static Interest Metrics Label -->
            <div class="cost-column">
              <span class="meta-label text-uppercase">Charges</span>
              <div class="charge-value-display">
                <span class="percentage-bold">{{ interestRate }}%</span>
                <span class="fixed-badge">(Fixed)</span>
              </div>
            </div>
  
            <!-- Column Right: Live Computed Repayment Counter -->
            <div class="cost-column align-items-end">
              <span class="meta-label text-uppercase">Total Repayment</span>
              <div class="repayment-value-display">
                <span class="currency-prefix-small">₦</span>{{ formattedTotalRepayment }}
              </div>
            </div>
  
          </div>
  
        </div>
  
        <!-- ─── REGULATORY FOOTER COMPLIANCE INFORMATION CHIP ─── -->
        <div class="legal-notice-box">
          <div class="info-icon-frame">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="16" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
          </div>
          <p class="legal-notice-paragraph">
            By confirming, you agree to the repayment schedule. The amount will be automatically deducted from your incoming rent payments.
          </p>
        </div>
        <div class="button-holder">
          <button class="btn main" @click="appyForAdvanceRent()" :disabled="loading">
            {{ loading ? 'Requesting...' : 'Request Rent Advance ' }}
          </button>
          <button class="btn cancel" @click="goBack()">Cancel</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Service } from "../../store/service";
  const Api = new Service();
  export default {
    name: 'AdvanceSummary',
    props: {
      initialAmount: {
        type: Number,
        default: 300000
      }
    },
    data() {
      return {
        loading: false,
        receivedAmount: 0,
        // localAmount: this.initialAmount,
        localAmount: this.receivedAmount,
        interestRate: 4.5, 
        maxLimit: 2500000,
      };
    },
    watch: {
      receivedAmount(newVal) {
        this.localAmount = newVal;
      }
    },
    computed: {
      formattedAmount() {
        return this.formatCurrency(this.localAmount);
      },
      calculatedTotalRepayment() {
        const chargeAmount = this.localAmount * (this.interestRate / 100);
        return this.localAmount + chargeAmount;
      },
      formattedTotalRepayment() {
        return this.formatCurrency(this.calculatedTotalRepayment);
      }
    },
    beforeRouteEnter(to, from, next) {
      const hasSavedData = sessionStorage.getItem('advanceAmount');

      if (!hasSavedData) { 
        // If 'from.path' is just the root '/' or empty, fallback to the selector route
        const fallbackPath = from.path !== '/' ? from.path : '/dashboard/advance-rent-amount';
        
        // Kick them back to where they came from
        next(fallbackPath);
      } else {
        // Data exists, allow the page to open normally
        next();
      }
    },
    beforeRouteLeave(to, from, next) {
      sessionStorage.removeItem('advanceAmount');
      next(); // Essential to let the navigation move forward
    },
    created() {
      const savedAmountData = sessionStorage.getItem('advanceAmount');
      if (savedAmountData) {
        this.receivedAmount = JSON.parse(savedAmountData);
      console.log('Selected AMOUNT:', this.receivedAmount);
      }
      // EventBus.$on('update-selection-summary', this.updateLocalData);
    },
    mounted() {
      
    },
    methods: {
      formatCurrency(value) {
        if (!value && value !== 0) return '0.00';
        return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      handleAmountInput(e) {
        let cleanString = e.target.value.replace(/,/g, '');
        
        if (cleanString === '' || isNaN(cleanString)) {
          this.localAmount = 0;
          this.$emit('amount-updated', 0);
          return;
        }
  
        const parsedFloat = parseFloat(cleanString);
        
        if (parsedFloat > this.maxLimit) {
          this.localAmount = this.maxLimit;
        } else {
          this.localAmount = parsedFloat;
        }
  
        this.$emit('amount-updated', this.localAmount);
        console.log("Main amount", this.localAmount)
      },
      goBack() {
        this.$router.go(-1)
      },
     
      async appyForAdvanceRent() {
        this.loading = true;
        try {
          await Api.postRequest(`apply-for-advanced-rent`, {amount: this.localAmount}).then(res => {
            console.log("Applied for advance rent", res);
            this.loading = false;
            console.log("Check", thos.loadin)
            if (res.data.success) {
              this.$store.commit("setApiSuccess", "Application sent pending verifications");
              this.$router.push("advance-rent-home");
              return;
            }
            if (res.data.error) {
              console.log("error check")
              return this.$store.commit("setApiFailed", res.data.error);
            }
          }).catch(err => {
            console.log("error:", err);
            this.loading = false;
          })
        } finally {
          this.loading = false;
          // console.log("closed")
        }
      }
    }
  };
  </script>
  
  <!-- ⚡ SCSS LAYOUT ENGINE WIRED UP BELOW ─── -->
  <style lang="scss" scoped>
  /* SCSS Variables */
  $font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  $surface-bg: #f8fafc;
  $card-white: #ffffff;
  $text-dark: #0f172a;
  $text-secondary: #64748b;
  $text-label: #94a3b8;
  $brand-blue: #0046e4;
  $border-muted: #f1f5f9;
  $notice-border: #e2e8f0;
  $breakpoint-mobile: 480px;
  
  .portal-wrapper {
    font-family: $font-sans;
    background-color: $surface-bg;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .summary-container {
    width: 100%;
    max-width: 480px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-radius: 28px;
    padding: 2.2rem 1rem;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.05), 0 12px 24px rgba(0, 0, 0, 0.05);
  }
  
  .summary-header {
    display: flex;
    flex-direction: column;
    gap: 6px;
  
    .main-title {
      font-size: 2rem;
      font-weight: 800;
      color: $text-dark;
      margin: 0;
      letter-spacing: -0.5px;
      
      @media (max-width: $breakpoint-mobile) {
        font-size: 1.75rem;
      }
    }
  
    .sub-title {
      font-size: 1.05rem;
      color: $text-secondary;
      line-height: 1.45;
      margin: 0;
  
      @media (max-width: $breakpoint-mobile) {
        font-size: 0.95rem;
      }
    }
  }
  
  .breakdown-card {
    background-color: $card-white;
    border-radius: 16px;
    padding: 32px 24px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.02), 0 8px 10px -6px rgba(0, 0, 0, 0.02);
    border: 1px solid $border-muted;
  
    @media (max-width: $breakpoint-mobile) {
      padding: 24px 16px;
    }
  
    .meta-label {
      font-size: 0.88rem;
      font-weight: 600;
      color: $text-label;
      letter-spacing: 0.25px;
  
      &.text-uppercase {
        text-transform: uppercase;
      }
    }
  
    .amount-requested-block {
      display: flex;
      flex-direction: column;
      gap: 8px;
  
      .input-display-row {
        display: flex;
        align-items: center;
        gap: 4px;
      }
  
      .currency-symbol, 
      .editable-amount-input {
        font-size: 2.5rem;
        font-weight: 800;
        color: $brand-blue;
        letter-spacing: -0.5px;
  
        @media (max-width: $breakpoint-mobile) {
          font-size: 2.1rem;
        }
      }
  
      .editable-amount-input {
        border: none;
        outline: none;
        width: 100%;
        padding: 0;
        margin: 0;
      }
  
      .currency-symbol {
        user-select: none;
      }
    }
  
    .card-divider {
      border: 0;
      height: 1px;
      background-color: $border-muted;
      margin: 28px 0;
    }
  
    .cost-summary-grid {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
  
      .cost-column {
        display: flex;
        flex-direction: column;
        gap: 6px;
  
        &.align-items-end {
          align-items: flex-end;
        }
      }
  
      .charge-value-display {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 2px;
  
        .percentage-bold {
          font-size: 1.35rem;
          font-weight: 700;
          color: $text-dark;
  
          @media (max-width: $breakpoint-mobile) {
            font-size: 1.15rem;
          }
        }
  
        .fixed-badge {
          font-size: 0.95rem;
          font-weight: 500;
          color: $text-secondary;
        }
      }
  
      .repayment-value-display {
        font-size: 1.45rem;
        font-weight: 800;
        color: $brand-blue;
        margin-top: 2px;
        display: flex;
        align-items: baseline;
  
        @media (max-width: $breakpoint-mobile) {
          font-size: 1.25rem;
        }
  
        .currency-prefix-small {
          font-size: 1.2rem;
          font-weight: 800;
          margin-right: 2px;
  
          @media (max-width: $breakpoint-mobile) {
            font-size: 1.05rem;
          }
        }
      }
    }
  }
  
  .legal-notice-box {
    border: 1px solid $notice-border;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
  
    .info-icon-frame {
      color: $text-secondary;
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
  
      svg {
        width: 100%;
        height: 100%;
      }
    }
  
    .legal-notice-paragraph {
      font-size: 0.92rem;
      color: $text-secondary;
      line-height: 1.5;
      font-weight: 400;
      margin: 0;
    }
  }

  .button-holder {
        margin-top: 30px;
        margin-bottom: 20px;
        width: 100%;
        button {
        width: 100%;
        height: 50px;
        font-family: Lato;
        box-shadow: none;
        outline: 0;
        }
        .main {
        background-color: #0033EA;
        color: #ffffff;
        margin-bottom: 15px;
        }
        .cancel {
        background-color: #E6F0FA;
        color: #0033EA;
        }
    }
  </style>
  